export default {
  ConnectMisaApp: {
    Title: 'Kết nối phần mềm MISA',
    MisaBumas: 'MISA Bumas',
    MisaBumasDescription:
      'Đơn vị theo dõi quản lý ngân sách trên MISA Bumas, Mimosa cung cấp số liệu quyết toán để đánh giá tình hình thực hiện dự toán.',
    MisaSalagov: 'MISA SalaGov',
    MisaSalagovDescription:
      'Đơn vị tính lương hệ số, phụ cấp...trên MISA SalaGov, chỉ dùng Mimosa để hạch toán kế toán.',
    MisaQLTS: 'MISA QLTS',
    MisaQLTSDescription: 'Đơn vị theo dõi tài sản chi tiết trên MISA QLTS, chỉ dùng Bamboo để hạch toán kế toán.',
    MisaEmis: 'MISA Emis',
    MisaEmisDescription:
      'Đơn vị theo dõi Khoản thu trường học chi tiết trên MISA EMIS, cung cấp dữ liệu cho phép Mimosa lập phiếu thu tiền học, các khoản dịch vụ.',
    MISAMeinvoice: 'MISA meInvoice',
    MISAMeinvoiceDescription: 'Kế toán lấy các hoá đơn đầu vào đã được kiểm tra tính hợp lệ, để hạch toán chứng từ kế toán.',
    MsgConnectSuccess: 'Kết nối {0} thành công',
    MisaLekima: 'MISA Lekima',
    MisaLekimaDescription: 'Kế toán nộp báo cáo trực tuyến cho Phòng Tài chính - Kế hoạch có sử dụng phần mềm MISA Lekima.'
  },
  ConnectQltsHasVoucher:
    'Phần mềm đã phát sinh chứng từ hạch toán TSCĐ trong năm <span class="color-green"><<{0}>></span>. Để đảm bảo tính chính xác của số liệu báo cáo, phần mềm sẽ tự động bỏ ghi các chứng từ đã phát sinh.',
  DisconnectQltsHasVoucher:
    'Phần mềm đã phát sinh chứng từ hạch toán TSCĐ từ MISA QLTS trong năm <span class="color-green"><<{0}>></span>. Để đảm bảo tính chính xác của số liệu báo cáo, phần mềm sẽ tự động bỏ ghi các chứng từ đã phát sinh.',
};
